var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.417,
    height: 15.567,
    viewBox: "0 0 17.417 15.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.268 -3.129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.766,12.1l7.126-7.126a4.521,4.521,0,1,1,6.392,6.393l-5.862,5.861",
    transform: "translate(-2.441)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1,22.009,6.521,27.587a3.264,3.264,0,0,1-4.6.06,3.265,3.265,0,0,1,.06-4.6l3.058-3.058",
    transform: "translate(0 -10.603)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.445,17.419l6.741-6.742a2.093,2.093,0,1,1,2.959,2.959l-1.991,1.991",
    transform: "translate(-6.122 -4.155)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.a6bf9d65f8d17a56389cb778172ee5fb.svg";
export { ForwardRef as ReactComponent };